import { useEffect, useState } from "react";

import Authors from "./Authors";
import Categories from "./Categories";
import JournalsList from "./JournalsList";

import {
  getJournalsAction,
  getJournalsByCategoryAction,
  getJournalSpeakersAction,
} from "../../store/Bible/BibleAction";

import { useDispatch, useSelector } from "react-redux";

const TWGJournals = () => {
  const dispatch = useDispatch();

  const { isMobile } = useSelector((state) => state.common);
  const { currentLanguageTitles, languagePreferred } = useSelector(
    (state) => state.languageReducer.data
  );

  const [activeBtn, setActiveBtn] = useState(0);
  const [journals, setJournals] = useState([]);
  const [journalsLoading, setJournalsLoading] = useState(false);
  const [authors, setAuthors] = useState([]);
  const [authorsLoading, setAuthorsLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(false);

  const fetchJournals = () => {
    setJournalsLoading(true);

    dispatch(
      getJournalsAction({
        apiPayloadRequest: { public: "true" },
        callback: (response) => {
          setJournals(response?.data);
          setJournalsLoading(false);
        },
      })
    );
  };

  const fetchSpeakers = () => {
    setAuthorsLoading(true);

    dispatch(
      getJournalSpeakersAction({
        callback: (response) => {
          setAuthors(response?.data);
          setAuthorsLoading(false);
        },
      })
    );
  };

  const fetchCategories = () => {
    setCategoriesLoading(true);

    dispatch(
      getJournalsByCategoryAction({
        callback: (response) => {
          setCategories(response?.data);
          setCategoriesLoading(false);
        },
      })
    );
  };

  useEffect(() => {
    fetchJournals();
    fetchSpeakers();
    fetchCategories();
  }, [languagePreferred]);

  return (
    <div className="flex w-full flex-1 flex-col overflow-y-auto bg-black">
      <div className="flex w-full items-center p-4 md:p-8">
        <div className="flex w-full flex-wrap items-center gap-2 md:gap-8">
          <button
            className={`rounded-full border px-4 py-1 md:px-8 ${
              activeBtn === 0
                ? "border-yellowish text-yellowish"
                : "border-greyish text-greyish"
            }`}
            onClick={() => setActiveBtn(0)}
          >
            {currentLanguageTitles?.[0]?.bible?.journals_lbl ?? "Journals"}
          </button>
          <button
            className={`rounded-full border px-4 py-1 md:px-8 ${
              activeBtn === 1
                ? "border-yellowish text-yellowish"
                : "border-greyish text-greyish"
            }`}
            onClick={() => setActiveBtn(1)}
          >
            {currentLanguageTitles?.[0]?.bible?.journal_categories_lbl ??
              "Categories"}
          </button>
          <button
            className={`rounded-full border px-4 py-1 md:px-8 ${
              activeBtn === 2
                ? "border-yellowish text-yellowish"
                : "border-greyish text-greyish"
            }`}
            onClick={() => setActiveBtn(2)}
          >
            {currentLanguageTitles?.[0]?.bible?.journal_authors_lbl ??
              "Authors"}
          </button>
        </div>
        {/* <div
          className={`min-w-[600px] flex items-center  bg-greyishV2 text-greyish gap-3 py-2 px-3 rounded-md`}
        >
          <LuSearch className="text-2xl text-greyish" />
          <input
            type="text"
            value={searchTxt}
            placeholder={"Search the Bible"}
            onChange={(e) => setSearchTxt(e.target.value)}
            className="w-full  bg-greyishV2 text-greyish outline-none text-lg"
          />
        </div> */}
      </div>
      <div
        className={`w-full p-5 md:p-8 ${activeBtn === 1 ? "pt-0" : "pt-4"}`}
        style={{
          gridAutoFlow: "row dense",
        }}
      >
        {activeBtn === 0 && (
          <>
            {journalsLoading ? (
              <div
                className={`grid gap-3 ${isMobile ? "grid-cols-2" : "grid-cols-8"}`}
              >
                <div className="flex flex-col gap-3">
                  <div className="aspect-[9/12] animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                  <div className="aspect-[9/12] animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                </div>
                <div className="flex flex-col gap-3">
                  <div className="aspect-[16/12] animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                  <div className="aspect-[14/16] animate-pulse rounded-3xl rounded-se-none bg-zinc-600"></div>
                  <div className="aspect-[16/14] animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                </div>
                {!isMobile && (
                  <>
                    <div className="flex flex-col gap-3">
                      <div className="aspect-[9/12] animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                      <div className="aspect-[9/12] animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                    </div>
                    <div className="flex flex-col gap-3">
                      <div className="aspect-[16/12] animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                      <div className="aspect-[14/16] animate-pulse rounded-3xl rounded-se-none bg-zinc-600"></div>
                      <div className="aspect-[16/14] animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                    </div>
                    <div className="flex flex-col gap-3">
                      <div className="aspect-[9/12] animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                      <div className="aspect-[9/12] animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                    </div>
                    <div className="flex flex-col gap-3">
                      <div className="aspect-[16/12] animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                      <div className="aspect-[14/16] animate-pulse rounded-3xl rounded-se-none bg-zinc-600"></div>
                      <div className="aspect-[16/14] animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                    </div>
                    <div className="flex flex-col gap-3">
                      <div className="aspect-[9/12] animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                      <div className="aspect-[9/12] animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                    </div>
                    <div className="flex flex-col gap-3">
                      <div className="aspect-[16/12] animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                      <div className="aspect-[14/16] animate-pulse rounded-3xl rounded-se-none bg-zinc-600"></div>
                      <div className="aspect-[16/14] animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                    </div>
                  </>
                )}
              </div>
            ) : (
              <JournalsList gridItems={isMobile ? 2 : 8} data={journals} />
            )}
          </>
        )}
        {activeBtn === 1 && (
          <>
            {categoriesLoading ? (
              <div className="flex w-full flex-col gap-12">
                <div className="flex flex-col gap-4">
                  <div className="flex items-center justify-between">
                    <div className="h-6 w-2/12 animate-pulse rounded-2xl bg-zinc-600"></div>
                    <div className="h-4 w-16 animate-pulse rounded-2xl bg-zinc-600"></div>
                  </div>
                  <div
                    className={`grid w-full gap-4 ${isMobile ? "grid-cols-2" : "grid-cols-6"}`}
                  >
                    <div className="aspect-video animate-pulse rounded-2xl bg-zinc-600"></div>
                    <div className="aspect-video animate-pulse rounded-2xl bg-zinc-600"></div>
                    {!isMobile && (
                      <>
                        <div className="aspect-video animate-pulse rounded-2xl bg-zinc-600"></div>
                        <div className="aspect-video animate-pulse rounded-2xl bg-zinc-600"></div>
                        <div className="aspect-video animate-pulse rounded-2xl bg-zinc-600"></div>
                        <div className="aspect-video animate-pulse rounded-2xl bg-zinc-600"></div>
                      </>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-4">
                  <div className="flex items-center justify-between">
                    <div className="h-6 w-2/12 animate-pulse rounded-2xl bg-zinc-600"></div>
                    <div className="h-4 w-16 animate-pulse rounded-2xl bg-zinc-600"></div>
                  </div>
                  <div
                    className={`grid w-full gap-4 ${isMobile ? "grid-cols-2" : "grid-cols-6"}`}
                  >
                    <div className="aspect-video animate-pulse rounded-2xl bg-zinc-600"></div>
                    <div className="aspect-video animate-pulse rounded-2xl bg-zinc-600"></div>
                    {!isMobile && (
                      <>
                        <div className="aspect-video animate-pulse rounded-2xl bg-zinc-600"></div>
                        <div className="aspect-video animate-pulse rounded-2xl bg-zinc-600"></div>
                        <div className="aspect-video animate-pulse rounded-2xl bg-zinc-600"></div>
                        <div className="aspect-video animate-pulse rounded-2xl bg-zinc-600"></div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <Categories data={categories} />
            )}
          </>
        )}
        {activeBtn === 2 && (
          <>
            {authorsLoading ? (
              <div className="grid w-full grid-cols-1 gap-10 md:grid-cols-3">
                <div className="flex gap-4">
                  <div className="aspect-square h-36 animate-pulse rounded-2xl bg-zinc-600"></div>
                  <div className="flex flex-1 flex-col gap-2">
                    <div className="h-8 w-full animate-pulse rounded-2xl bg-zinc-600"></div>
                    <div className="h-4 w-8/12 animate-pulse rounded-2xl bg-zinc-600"></div>
                    <div className="h-4 w-4/12 animate-pulse rounded-2xl bg-zinc-600"></div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="aspect-square h-36 animate-pulse rounded-2xl bg-zinc-600"></div>
                  <div className="flex flex-1 flex-col gap-2">
                    <div className="h-8 w-full animate-pulse rounded-2xl bg-zinc-600"></div>
                    <div className="h-4 w-8/12 animate-pulse rounded-2xl bg-zinc-600"></div>
                    <div className="h-4 w-4/12 animate-pulse rounded-2xl bg-zinc-600"></div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="aspect-square h-36 animate-pulse rounded-2xl bg-zinc-600"></div>
                  <div className="flex flex-1 flex-col gap-2">
                    <div className="h-8 w-full animate-pulse rounded-2xl bg-zinc-600"></div>
                    <div className="h-4 w-8/12 animate-pulse rounded-2xl bg-zinc-600"></div>
                    <div className="h-4 w-4/12 animate-pulse rounded-2xl bg-zinc-600"></div>
                  </div>
                </div>
                {!isMobile && (
                  <>
                    <div className="flex gap-4">
                      <div className="aspect-square h-36 animate-pulse rounded-2xl bg-zinc-600"></div>
                      <div className="flex flex-1 flex-col gap-2">
                        <div className="h-8 w-full animate-pulse rounded-2xl bg-zinc-600"></div>
                        <div className="h-4 w-8/12 animate-pulse rounded-2xl bg-zinc-600"></div>
                        <div className="h-4 w-4/12 animate-pulse rounded-2xl bg-zinc-600"></div>
                      </div>
                    </div>
                    <div className="flex gap-4">
                      <div className="aspect-square h-36 animate-pulse rounded-2xl bg-zinc-600"></div>
                      <div className="flex flex-1 flex-col gap-2">
                        <div className="h-8 w-full animate-pulse rounded-2xl bg-zinc-600"></div>
                        <div className="h-4 w-8/12 animate-pulse rounded-2xl bg-zinc-600"></div>
                        <div className="h-4 w-4/12 animate-pulse rounded-2xl bg-zinc-600"></div>
                      </div>
                    </div>
                    <div className="flex gap-4">
                      <div className="aspect-square h-36 animate-pulse rounded-2xl bg-zinc-600"></div>
                      <div className="flex flex-1 flex-col gap-2">
                        <div className="h-8 w-full animate-pulse rounded-2xl bg-zinc-600"></div>
                        <div className="h-4 w-8/12 animate-pulse rounded-2xl bg-zinc-600"></div>
                        <div className="h-4 w-4/12 animate-pulse rounded-2xl bg-zinc-600"></div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            ) : (
              <Authors data={authors} />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TWGJournals;
